import React from 'react';

import SvgContainer from '../SvgContainer';

const FourLevelThree = () => {
    return (
        <SvgContainer>
            <g clipPath="url(#clip0_9085_100967)">
                <path d="M2.66667 14.7368V12.2105C2.66667 11.5129 2.06971 10.9474 1.33333 10.9474C0.596954 10.9474 0 11.5129 0 12.2105V14.7368C0 15.4345 0.596954 16 1.33333 16C2.06971 16 2.66667 15.4345 2.66667 14.7368Z" />
                <path d="M11.5556 14.7368V4.63158C11.5556 3.93396 10.9586 3.36842 10.2222 3.36842C9.48584 3.36842 8.88889 3.93396 8.88889 4.63158V14.7368C8.88889 15.4345 9.48584 16 10.2222 16C10.9586 16 11.5556 15.4345 11.5556 14.7368Z" />
                <path d="M4.44444 8C4.44444 7.30238 5.0414 6.73684 5.77778 6.73684C6.51416 6.73684 7.11111 7.30238 7.11111 8V14.7368C7.11111 15.4345 6.51416 16 5.77778 16C5.0414 16 4.44444 15.4345 4.44444 14.7368V8Z" />
                <path
                    d="M16 1.26316V14.7368C16 15.4345 15.403 16 14.6667 16C13.9303 16 13.3333 15.4345 13.3333 14.7368V1.26316C13.3333 0.565535 13.9303 0 14.6667 0C15.403 0 16 0.565535 16 1.26316Z"
                    fillOpacity="0.3"
                />
            </g>
            <defs>
                <clipPath id="clip0_9085_100967">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </SvgContainer>
    );
};

export default FourLevelThree;
